import type { ReactNode } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import type { SvgIconComponent } from "@mui/icons-material";

export interface StatMetricCardProps {
  icon: SvgIconComponent;
  color: string;
  label: string;
  value: ReactNode;
  sub?: string;
}

/**
 * Shared metric tile (dashboard, analytics, etc.).
 */
export function StatMetricCard({
  icon: Icon,
  color,
  label,
  value,
  sub,
}: StatMetricCardProps) {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent
        sx={{
          textAlign: "center",
          py: 2.5,
          px: 2,
          "&:last-child": { pb: 2.5 },
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: `${color}20`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 1.5,
          }}
        >
          <Icon sx={{ color, fontSize: 26 }} />
        </Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 0.5,
            wordBreak: "break-word",
          }}
        >
          {value}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontWeight: 500,
          }}
        >
          {label}
        </Typography>
        {sub ? (
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "text.secondary",
              mt: 0.5,
            }}
          >
            {sub}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}
